import React from 'react'
import SideBar from '../../Components/Admin/SideBar'
import AdminPollsComponent from '../../Components/Admin/AdminPollsComponent'

export default function AdminPollsPage() {
  return (
    <AdminPollsComponent />
  )
}
